export default __webpack_public_path__ + "static/media/MyPhoto.c00e7935.jpg";